import {Alert, Button, Col, Icon, Modal, Row, Tooltip} from "antd";
import React, {Fragment, useCallback, useEffect, useState} from "react";
import {translate} from "react-i18next";
import {connect} from 'react-redux';
import {compose} from "redux";
import EnhancedModal from "../../../../../components/enhanced-modal";
import Call from "../../../../../hocs/call";
import {GUTTER_SM, MODAL_WIDTH_XL} from "../../../../../styles/constants";
import {
    deleteDimensionTranscoding,
    getDataFromDatasetColumn,
    hideTranscodingSettingsTimeDimension,
    saveTimeDimensionTranscoding
} from "../actions";
import {
    arraySubstrings,
    generateDataTimeDimensionTable,
    generateDataTimeDimensionTableEdit,
    generatePeriods,
    getNewCard,
    validateErrorsByCards,
    validateErrorsByInput,
    validateTimeDimensionInputs
} from "./utils";
import FrequencyCard from "./FrequencyCard";

const mapStateToProps = state => ({
    showTranscodingSettingsTimeDimension: state.scenes.mappingHandler.mappingSet.transcoding.showTranscodingSettingsTimeDimension,
    data: state.scenes.mappingHandler.mappingSet.transcoding.data,
    selectedDataset: state.scenes.mappingHandler.mappingSet.wizard.selectedDataset,
    slidersValue: state.scenes.mappingHandler.mappingSet.transcoding.slidersValue,
    timeTranscodings: state.scenes.mappingHandler.mappingSet.transcoding.timeTranscodings,
    // transcodingEntityId: state.scenes.mappingHandler.mappingSet.transcoding.data.entityId,
    informationTable: state.scenes.mappingHandler.mappingSet.transcoding.informationTable,
    columnData: state.scenes.mappingHandler.mappingSet.transcoding.columnData
})

const mapDispatchToProps = dispatch => ({
    onHideTranscodingSettings: () => dispatch(hideTranscodingSettingsTimeDimension()),
    onSaveTimeDimensionTranscoding: ({
                                         data,
                                         timeTranscodings,
                                         idTimeDimensionMapping
                                     }) => dispatch(saveTimeDimensionTranscoding(data, timeTranscodings, idTimeDimensionMapping)),
    onDeleteTimeDimensionTranscoding: (data) => dispatch(deleteDimensionTranscoding(data, true)),
    onSelectColumn: ({datasetId, columnName}) => dispatch(getDataFromDatasetColumn(datasetId, columnName))
})

const TranscodingTimeDimension = ({
                                      t,
                                      showTranscodingSettingsTimeDimension,
                                      onHideTranscodingSettings,
                                      data,
                                      selectedDataset,
                                      slidersValue,
                                      onSaveTimeDimensionTranscoding,
                                      timeTranscodings,
                                    //   transcodingEntityId,
                                      onDeleteTimeDimensionTranscoding,
                                      onSelectColumn,
                                      columnData
                                  }) => {
    const [frequencyCards, setFrequencyCards] = useState([getNewCard()]);
    const [inputErrors, setInputErrors] = useState({});
    const [showValidationAlert, setShowValidationAlert] = useState(false);


    const handleInputChange = useCallback((index, key, value) => {
        setFrequencyCards(prevState => {
            const updatedCards = [...prevState];
            updatedCards[index].dataTable = updatedCards[index].dataTable.map((record) => {
                if (record.key === key) {
                    return {
                        ...record,
                        [`${record.key}`]: value,
                        localPeriod: value,
                    };
                }
                return record;
            })
            return updatedCards;
        });
        setInputErrors(prevState => validateErrorsByInput(index, key, value, frequencyCards, false, columnData, prevState));
    }, [columnData, frequencyCards]);

    useEffect(() => {
        if (timeTranscodings && timeTranscodings.length > 0 && (slidersValue && slidersValue.length > 0) && columnData) {
            const updateTranscodings = timeTranscodings.map((valueTranscoding) => ({
                frequency: valueTranscoding.frequency,
                optionYearColumn: valueTranscoding.year && valueTranscoding.year.dataSetColumnName,
                optionPeriodColumn: valueTranscoding.period && valueTranscoding.period.dataSetColumnName,
                dataTable: generateDataTimeDimensionTableEdit(valueTranscoding.periodRules),
                periodMarks: valueTranscoding.period ? valueTranscoding.period && generatePeriods((slidersValue.filter((index) => index.name === valueTranscoding.period.dataSetColumnName).map((x) => x.value)[0])) : {
                    marks: {
                        0: '-'
                    },
                    step: 0,
                    max: 0
                },
                yearMarks: valueTranscoding.year && generatePeriods((slidersValue.filter((index) => index.name === valueTranscoding.year.dataSetColumnName).map((x) => x.value)[0])),
                yearSlider: valueTranscoding.year && [valueTranscoding.year.start, (valueTranscoding.year.start + (valueTranscoding.year.length > 0 ? (valueTranscoding.year.length - 1) : valueTranscoding.year.length))],
                periodSlider: valueTranscoding.period && [valueTranscoding.period.start, (valueTranscoding.period.start + (valueTranscoding.period.length > 0 ? (valueTranscoding.period.length - 1) : valueTranscoding.period.length))],
                yearData: null,
                periodData: null,
            }));

            setInputErrors(prevState => validateErrorsByCards(updateTranscodings, false, columnData, prevState));

            setFrequencyCards(updateTranscodings);
        }
    }, [timeTranscodings, slidersValue, columnData]);

    const resetAllStates = useCallback(() => {
        setFrequencyCards([getNewCard()]);
        setShowValidationAlert(false)
    }, []);

    const handleCloseModal = useCallback(() => {
        resetAllStates();
        onHideTranscodingSettings();
    }, [resetAllStates]);

    const handleSave = useCallback(() => {
        const areAllValid = frequencyCards.every((item) => validateTimeDimensionInputs(item));
        if (!areAllValid) {
            setShowValidationAlert(true)
            return;
        }
        let transcodingsForSave = []
        frequencyCards.forEach((item) => {
            let PeriodRules = null
            if (item.dataTable)
                PeriodRules = item.dataTable.map((record) => ({
                    PeriodId: record.sdmxPeriod,
                    LocalCode: record[record.sdmxPeriod],
                }));
            const selectYearId = data.columnObject.filter((val) => val.name === item.optionYearColumn).map((entity) => entity.entityId)[0]
            const selectPeriodId = data.columnObject.filter((val) => val.name === item.optionPeriodColumn).map((entity) => entity.entityId)[0]
            const Year = item.optionYearColumn && {
                DataSetColumnName: item.optionYearColumn,
                DataSetColumnEntityId: selectYearId,
                Start: item.yearSlider[0],
                Length: (item.yearSlider[1] - item.yearSlider[0]) + 1
            }
            const Period = item.optionPeriodColumn && {
                DataSetColumnName: item.optionPeriodColumn,
                DataSetColumnEntityId: selectPeriodId,
                Start: item.periodSlider[0],
                Length: (item.periodSlider[1] - item.periodSlider[0]) + 1
            }
            transcodingsForSave.push({
                Frequency: item.frequency,
                Year: Year,
                Period: Period,
                PeriodRules: PeriodRules,
                IsDateTime: false
            })
        })
        onSaveTimeDimensionTranscoding({
            data,
            timeTranscodings: transcodingsForSave,
            idTimeDimensionMapping: data.entityId && data.entityId
        });
        resetAllStates();
        onHideTranscodingSettings();
    }, [frequencyCards, data, resetAllStates]);

    const handleFrequency = useCallback((cardIndex, freq) => {
        const updatedCards = [...frequencyCards];
        updatedCards[cardIndex].frequency = freq;
        updatedCards[cardIndex].dataTable = generateDataTimeDimensionTable(freq);
        if (freq === 'A' && updatedCards[cardIndex].optionPeriodColumn) {
            updatedCards[cardIndex].optionPeriodColumn = null
        }
        setInputErrors(prevState => validateErrorsByCards(updatedCards, true, columnData, prevState));
        setFrequencyCards(updatedCards);
    }, [frequencyCards, columnData, inputErrors]);


    const handleSelect = useCallback((cardIndex, value, isYear) => {
        const updatedCards = [...frequencyCards];
        const generatedPeriod = generatePeriods((slidersValue.filter((index) => index.name === value).map((x) => x.value)[0]))
        if (isYear) {
            updatedCards[cardIndex].yearMarks = null
            updatedCards[cardIndex].yearSlider = null
            updatedCards[cardIndex].yearMarks = generatedPeriod;
            updatedCards[cardIndex].optionYearColumn = value
            updatedCards[cardIndex].yearSlider = [0, generatedPeriod.max ? generatedPeriod.max : 0]
        } else {
            updatedCards[cardIndex].periodMarks = generatedPeriod;
            updatedCards[cardIndex].optionPeriodColumn = value
            updatedCards[cardIndex].periodSlider = [0, generatedPeriod.max ? generatedPeriod.max : 0]
        }

        if (updatedCards[cardIndex].optionPeriodColumn || updatedCards[cardIndex].optionPeriodColumn) {
            setInputErrors(prevState => validateErrorsByCards(updatedCards, false, columnData, prevState));
        }
        setFrequencyCards(updatedCards);
    }, [frequencyCards, slidersValue, columnData, inputErrors]);

    const handleChangeSlider = useCallback((cardIndex, value, isYear) => {
        const updatedCards = [...frequencyCards];
        let columnName = null
        if (isYear) {
            columnName = updatedCards[cardIndex].optionYearColumn
            updatedCards[cardIndex].yearSlider = value;
        } else {
            columnName = updatedCards[cardIndex].optionPeriodColumn
            updatedCards[cardIndex].periodSlider = value;
        }

        if (updatedCards[cardIndex].frequency !== 'A') {

            const selectedPeriod = (value[1] - value[0]) + 1;
            setInputErrors(prevState => {
                const newInputErrors = {...prevState};
                updatedCards[cardIndex].dataTable.forEach((tableItem) => {
                    if (
                        (updatedCards[cardIndex].optionYearColumn && isYear && !updatedCards[cardIndex].optionPeriodColumn) ||
                        (updatedCards[cardIndex].optionYearColumn && !isYear && updatedCards[cardIndex].optionPeriodColumn)
                    ) {
                        if (selectedPeriod < tableItem.localPeriod.length || !tableItem.localPeriod) {
                            newInputErrors[`localPeriod_${tableItem.key}`] = 'error';
                        } else {
                            const res = arraySubstrings(columnName, columnData, value)
                            if (res && res.some(val => val.includes(tableItem.localPeriod))) {
                                newInputErrors[`localPeriod_${tableItem.key}`] = '';
                            } else {
                                newInputErrors[`localPeriod_${tableItem.key}`] = 'error';
                            }
                        }
                    }
                });
                return newInputErrors;
            });
        }
        setFrequencyCards(updatedCards);
    }, [frequencyCards, columnData, inputErrors]);

    return (
        <Fragment>
            <EnhancedModal
                title={t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.timeDimensionTranscoding.title")}
                visible={showTranscodingSettingsTimeDimension}
                width={MODAL_WIDTH_XL}
                withDataLanguageSelector
                onCancel={handleCloseModal}
                footer={
                    <Fragment>
                        <Row type="flex" align="middle" justify="end" gutter={GUTTER_SM}>
                            <Col>
                                <Tooltip
                                    title={t("scenes.mappingHandler.MappingSet.transcoding.tooltip.deleteTranscodingButton")}>
                                    <Button
                                        disabled={timeTranscodings == null}
                                        type="delete"
                                        onClick={() => Modal.confirm({
                                            title: t('commons.artefact.modals.transcoding.delete.title'),
                                            onOk() {
                                                resetAllStates();
                                                onHideTranscodingSettings();
                                                onDeleteTimeDimensionTranscoding(data)
                                            },
                                            cancelText: t('commons.buttons.cancel.title')
                                        })}
                                    >
                                        <Icon
                                            type="delete"
                                        />
                                        {t('scenes.mappingHandler.MappingSet.transcoding.buttons.delete')}
                                    </Button>
                                </Tooltip>
                            </Col>
                            <Col>
                                <Button
                                    onClick={handleCloseModal}
                                >
                                    {t('commons.buttons.close.title')}
                                </Button>
                            </Col>
                            <Col>
                                <Button
                                    type="primary"
                                    onClick={() =>
                                        Modal.confirm({
                                            title: t('commons.artefact.modals.unsavedChange.autoSave.title'),
                                            onOk() {
                                                handleSave();
                                            },
                                            cancelText: t('commons.buttons.cancel.title')
                                        })
                                    }
                                >
                                    {t('commons.buttons.save.title')}
                                </Button>
                            </Col>
                        </Row>
                    </Fragment>
                }
            >
                {showValidationAlert && (
                    <Alert
                        message={t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcoding.messages.mandatoryFields")}
                        type="error"
                        showIcon
                    />
                )}
                <Tooltip
                    title={t("scenes.mappingHandler.MappingSet.transcoding.tooltip.clearTranscodingTimeDimensionButton")}>
                    <Button style={{marginBottom: 10}} onClick={() =>
                        Modal.confirm({
                            title: t('commons.artefact.modals.transcoding.clear.title'),
                            onOk() {
                                resetAllStates();
                            },
                            cancelText: t('commons.buttons.cancel.title')
                        })
                    }
                    >
                        <Icon
                            type="delete"
                        />
                        {t('scenes.mappingHandler.MappingSet.transcoding.buttons.clear')}
                    </Button>
                </Tooltip>
                {data && selectedDataset && (
                    <Call cb={onSelectColumn} cbParam={{
                        datasetId: selectedDataset.id,
                        columnName: (data ? data.columnName : [])
                    }} disabled={!!slidersValue && slidersValue.length > 0}>
                        {frequencyCards.map((card, index) => (
                            <FrequencyCard card={card} key={index} index={index}
                                           frequencyCards={frequencyCards}
                                           setFrequencyCards={setFrequencyCards}
                                           data={data}
                                           handleFrequency={handleFrequency}
                                           handleChangeSlider={handleChangeSlider}
                                           handleSelect={handleSelect}
                                           handleInputChange={handleInputChange}
                                           inputErrors={inputErrors}/>
                        ))}
                    </Call>
                )}
                {frequencyCards && frequencyCards.length < 4 && (
                    <Tooltip
                        title={t("scenes.mappingHandler.MappingSet.transcoding.tooltip.addFrequency")}>
                        <Button style={{marginTop: 10}}
                                onClick={() => setFrequencyCards(prevState => [...prevState, getNewCard()])}
                        >
                            <Icon
                                type="plus"
                            />
                            {t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcoding.buttons.timeTranscoding.addFrequency")}
                        </Button>
                    </Tooltip>)}
            </EnhancedModal>
        </Fragment>)
};

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(TranscodingTimeDimension);